import styled from '@emotion/styled';

export const SectionHeader = styled.div`
  margin-left: 16px;
  margin-top: 12px;
  margin-bottom: 8px;
`;
